import { DTOTierPrice } from "vue-app/api/dto";
import { dayjsWithTz } from "vue-app/utils/functions";

export const getPackage = (value: number, packages: DTOTierPrice[] | null): DTOTierPrice | null => {
  if (!packages || packages.length === 0) {
    return null;
  }

  const lastPackage = packages[packages.length - 1];
  if (lastPackage.fromUnits !== null && value >= lastPackage.fromUnits) {
    return lastPackage;
  }

  return (
    packages.find((pkg) => {
      const from = pkg.fromUnits ?? -Infinity;
      const upTo = pkg.upToUnits ?? Infinity;
      return value >= from && value <= upTo;
    }) || null
  );
};

export function roundUpToNearest10AfterMultiplyingBy3(value?: number | null, max?: number | null): number {
  if (!value) {
    return 500;
  }
  let size = Math.ceil((value * 3) / 10) * 10;
  if (size < 500) {
    size = 500;
  }
  return max ? Math.min(size, max) : size;
}

export function getSubscriptionPackageSize(packageSize: number, credits) {
  if (packageSize) {
    return packageSize;
  }

  const freeCredits = credits?.find((credit) => credit.freePackage);
  if (freeCredits?.packageSize) {
    return freeCredits.packageSize;
  }
  
  return 0;
}

export function getTotalCredits(credits, key: string) {
  if (!credits) {
    return 0;
  }
  return credits.reduce((acc, val) => acc + val[key], 0);
}

export function getRenewalDate(date: number) {
  if (date) {
    return dayjsWithTz(date).format("D MMMM");
  }
  return dayjsWithTz().add(1, "month").startOf("month").format("D MMMM");
}
